<script>
  import Select from 'svelte-select';
  import { customInputEvent, searchKeyByValue } from 'components/Helper.js';
  import FormInput from 'components/FormControls/FormInput.svelte';

  let months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
  ];

  export let type = 1;
  export let form;
  export let errors;
  export let handleChange;
  export let recurringTypeOptions;
  export let recurringType;
  export let disabledAllFields = false;
  export let dateRecurringSubTypes = [];

  let title;
  let recurringSubType;
  let selectedMonth;
  let selectedDay;

  let days28 = [];
  for (let i = 1; i <= 28; i++) {
    days28.push({ id: i, name: i.toString() });
  }

  let days = [];
  const setDays = (month) => {
    let year = new Date().getFullYear();
    let oldDays = [];
    var maxDays = month == undefined ? 28 : new Date(year, month, 0).getDate();
    for (let i = 1; i <= maxDays; i++) {
      oldDays.push({ id: i, name: i.toString() });
    }
    days = oldDays;
  };
  setDays(type == 1 ? $form.recurringOpenMonth : $form.recurringDueMonth);
  if (type == 1) {
    title = 'Open Date';
    recurringSubType = $form.recurringOpenType;
    if ($form.recurringOpenOn > 0) {
      selectedDay = days[searchKeyByValue(days, 'id', $form.recurringOpenOn)];
    }
    if ($form.recurringOpenMonth > 0) {
      selectedMonth = months[searchKeyByValue(months, 'id', $form.recurringOpenMonth)];
    }
  } else {
    title = 'Due Date';
    recurringSubType = $form.recurringDueType;
    if ($form.recurringDueOn > 0) {
      selectedDay = days[searchKeyByValue(days, 'id', $form.recurringDueOn)];
    }
    if ($form.recurringDueMonth > 0) {
      selectedMonth = months[searchKeyByValue(months, 'id', $form.recurringDueMonth)];
    }
  }

  export const resetRecurringData = () => {
    $form.recurringEvery = 1;
    $form.recurringOpenType = '';
    $form.recurringOpenOn = '';
    $form.recurringOpenMonth = '';
    $form.recurringDueType = '';
    $form.recurringDueOn = '';
    $form.recurringDueMonth = '';
    selectedDay = null;
    selectedMonth = null;
    recurringSubType = null;
  };
</script>

{#if recurringType == recurringTypeOptions.monthly || recurringType == recurringTypeOptions.quarterly || recurringType == recurringTypeOptions.annually}
  <div class="d-flex flex-row align-items-center justify-content-start add-client-title mb-3">
    <span class="font-weight-500 text-nowrap">{title}</span>
    <div class="hrline w-100 ms-3"></div>
  </div>

  <div class="col-md-12 mb-3 position-relative">
    <div class="row">
      {#if recurringType == recurringTypeOptions.annually || recurringType == recurringTypeOptions.quarterly}
        <div class="col-md-6 mb-2 align-items-center justify-content-center">
          <div
            class="d-flex flex-row align-items-center repeats-block-content justify-content-start h-100 position-relative {$errors.recurringOpenMonth ||
            $errors.recurringDueMonth
              ? 'error'
              : ''} "
          >
            <label
              for=""
              class="me-2">Select Month</label
            >
            <div class="position-relative">
              <Select
                isDisabled={disabledAllFields}
                bind:selectedValue={selectedMonth}
                showChevron={true}
                isClearable={false}
                items={months}
                placeholder="Select Month"
                optionIdentifier="id"
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                getOptionLabel={(option) => {
                  return option.name;
                }}
                containerClasses="form-control"
                containerStyles="width:150px; height:35px;"
                on:select={(ev) => {
                  if (type == 1) {
                    $form.recurringOpenMonth = ev.detail.id;
                    handleChange(customInputEvent('recurringOpenMonth', ev.detail.id));
                  } else {
                    $form.recurringDueMonth = ev.detail.id;
                    handleChange(customInputEvent('recurringDueMonth', ev.detail.id));
                  }
                  setDays(ev.detail.id);
                  if (type == 1) {
                    $form.recurringOpenOn = '';
                    handleChange(customInputEvent('recurringOpenOn', $form.recurringOpenOn));
                  } else {
                    $form.recurringDueOn = '';
                    handleChange(customInputEvent('recurringDueOn', $form.recurringDueOn));
                  }
                  selectedDay = null;
                }}
              ></Select>

              {#if type == 1 && $errors.recurringOpenMonth}
                <label
                  for=""
                  class="formError"
                >
                  {$errors.recurringOpenMonth}
                </label>
              {/if}

              {#if type == 2 && $errors.recurringDueMonth}
                <label
                  for=""
                  class="formError"
                >
                  {$errors.recurringDueMonth}
                </label>
              {/if}
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-2 align-items-center justify-content-center">
          <div
            class="d-flex flex-row align-items-center repeats-block-content justify-content-start h-100 position-relative {$errors.recurringOpenOn ||
            $errors.recurringDueOn
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="me-2">Select Day</label
            >
            <div class="position-relative">
              <Select
                isDisabled={disabledAllFields}
                bind:selectedValue={selectedDay}
                showIndicator={true}
                items={days}
                placeholder="Select Day"
                showChevron={true}
                isClearable={false}
                containerStyles="width:150px; height:35px;"
                optionIdentifier="id"
                containerClasses="form-control"
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                getOptionLabel={(option) => {
                  return option.name;
                }}
                on:select={(ev) => {
                  if (type == 1) {
                    $form.recurringOpenOn = ev.detail.id;
                    handleChange(customInputEvent('recurringOpenOn', ev.detail.id));
                  } else {
                    $form.recurringDueOn = ev.detail.id;
                    handleChange(customInputEvent('recurringDueOn', ev.detail.id));
                  }
                }}
              ></Select>
              {#if type == 1 && $errors.recurringOpenOn}
                <label
                  for=""
                  class="formError recuring-error"
                >
                  {$errors.recurringOpenOn}
                </label>
              {/if}

              {#if type == 2 && $errors.recurringDueOn}
                <label
                  for=""
                  class="formError recuring-error"
                >
                  {$errors.recurringDueOn}
                </label>
              {/if}
            </div>
          </div>
        </div>
      {:else if recurringType == recurringTypeOptions.quarterly}
        {#each dateRecurringSubTypes as dateRecurringSubType}
          <div class="col-md-3 mb-2">
            <button
              disabled={disabledAllFields}
              on:click={() => {
                if (type == 1) {
                  $form.recurringOpenType = dateRecurringSubType.id;
                  $form.recurringOpenOn = dateRecurringSubType.value;
                  handleChange(customInputEvent('recurringOpenType', $form.recurringOpenType));
                  handleChange(customInputEvent('recurringOpenOn', $form.recurringOpenOn));
                } else {
                  $form.recurringDueType = dateRecurringSubType.id;
                  $form.recurringDueOn = dateRecurringSubType.value;

                  handleChange(customInputEvent('recurringDueType', $form.recurringDueType));
                  handleChange(customInputEvent('recurringDueOn', $form.recurringDueOn));
                }
                recurringSubType = dateRecurringSubType.id;
              }}
              class="d-flex flex-row align-items-center button-weekly position-relative w-100 bg-white {recurringSubType ==
              dateRecurringSubType.id
                ? 'active'
                : ''}"
            >
              <button
                class="remove-btn bg-transparent border-0"
                on:click={(e) => {
                  e.stopImmediatePropagation();
                  if (type == 1) {
                    $form.recurringOpenType = '';
                    $form.recurringOpenOn = '';
                  } else {
                    $form.recurringDueType = '';
                    $form.recurringDueOn = '';
                  }
                  recurringSubType = undefined;
                  return false;
                }}
                ><img
                  alt=""
                  src="/images/close.svg"
                /></button
              >
              <div class="d-flex flex-column day-every">
                <small class="text-start me-1">Repeats<br />on</small>
              </div>
              <div class="number-unit d-flex align-items-center justify-content-center">
                {dateRecurringSubType.value}<sup>{dateRecurringSubType.suffix}</sup>
              </div>
              <div class="d-flex flex-column day-every">
                <small>Every</small>
                <span class="font-weight-600"> 3 Month</span>
              </div>
            </button>
          </div>
        {/each}

        <!-- <div class="col-md-3 mb-2">
							  <button
							  disabled={disabledAllFields}
								on:click={()=>{
									if(type ==1){
										$form.recurringOpenType=1;
										$form.recurringOpenOn=1;
										 handleChange(customInputEvent('recurringOpenType', 1));
										 handleChange(customInputEvent('recurringOpenOn', 1));
									  }else{
										$form.recurringDueType=1;
										$form.recurringDueOn=7;

										 handleChange(customInputEvent('recurringDueType', 1));
										 handleChange(customInputEvent('recurringDueOn', 7));
									  }
									  recurringSubType=1;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==1?'active':''}">

									  <div class="d-flex flex-column day-every">
										  <small class="text-start me-1">Repeats<br/>on</small>
									  </div>
									 <div class="number-unit  d-flex align-items-center justify-content-center ">
										{#if type ==1}
										  1<sup>st</sup>
										{:else}
										  7<sup>th</sup>
										{/if}
									  </div>
									  <div class="d-flex flex-column day-every">
										<small>Every</small>
										<span class="font-weight-600"> 3 Month</span>
									  </div>

							  </button>
						  </div>

						   <div class="col-md-3  mb-2">
							  <button
							  disabled={disabledAllFields}
							   on:click={()=>{
								 if(type ==1){
										$form.recurringOpenType=2;
										$form.recurringOpenOn=14;
										   handleChange(customInputEvent('recurringOpenType', 2));
										 handleChange(customInputEvent('recurringOpenOn', 14));
								  }else{
									  $form.recurringDueType=2;
									  $form.recurringDueOn=14;
									   handleChange(customInputEvent('recurringDueType', 2));
										 handleChange(customInputEvent('recurringDueOn', 14));
									}
									recurringSubType=2;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==2?'active':''}">

							   <div class="d-flex flex-column day-every">
										  <small class="text-start me-1">Repeats<br/>on</small>
								</div>
								<div class="number-unit  d-flex align-items-center justify-content-center ">14<sup>th</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>Every</small>
								  <span class="font-weight-600">3 Month</span>
								</div>
							  </button>
						  </div>
						   <div class="col-md-3  mb-2">
							  <button
							   disabled={disabledAllFields}
							   on:click={()=>{
								   if(type ==1){
										$form.recurringOpenType=3;
										$form.recurringOpenOn=21;
										 handleChange(customInputEvent('recurringOpenType', 3));
										 handleChange(customInputEvent('recurringOpenOn', 21));
									}else{
									  $form.recurringDueType=3;
									  $form.recurringDueOn=21;
										handleChange(customInputEvent('recurringDueType', 3));
										handleChange(customInputEvent('recurringDueOn', 21));
									}

									recurringSubType=3;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==3?'active':''}">
							   <div class="d-flex flex-column day-every">
										  <small class="me-1 text-start">Repeats<br/>on</small>
								</div>
								<div class="number-unit  d-flex align-items-center justify-content-center ">21<sup>st</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>Every</small>
								  <span class="font-weight-600">3 Month</span>
								</div>
							  </button>
						  </div>
						   <div class="col-md-3  mb-2">
							  <button
							   disabled={disabledAllFields}
							   on:click={()=>{
								  if(type ==1){
										$form.recurringOpenType=4;
										$form.recurringOpenOn=28;
										 handleChange(customInputEvent('recurringOpenType', 4));
										 handleChange(customInputEvent('recurringOpenOn', 28));
									}else{
									  $form.recurringDueType=4;
									  $form.recurringDueOn=28;
									  handleChange(customInputEvent('recurringDueType', 4));
										handleChange(customInputEvent('recurringDueOn', 28));
									}
									recurringSubType=4;
								}}
							   class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==4?'active':''}">
							   <div class="d-flex flex-column day-every">
										  <small class="me-1 text-start">Repeats<br/>on</small>
								</div>
								<div class="number-unit  d-flex align-items-center justify-content-center ">28<sup>th</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>Every</small>
								  <span class="font-weight-600"> 3 Month</span>
								</div>
							  </button>
						  </div> -->

        <div class="col-md-3 mb-2">
          <button
            disabled={disabledAllFields}
            on:click={() => {
              if (type == 1) {
                $form.recurringOpenType = 5;
                $form.recurringOpenOn = '';
                selectedDay = undefined;
                handleChange(customInputEvent('recurringOpenType', 5));
              } else {
                $form.recurringDueType = 5;
                $form.recurringDueOn = '';
                selectedDay = undefined;
                handleChange(customInputEvent('recurringDueType', 5));
              }
              recurringSubType = 5;
            }}
            class="d-flex flex-row align-items-center button-weekly position-relative w-100 bg-white {recurringSubType ==
            5
              ? 'active'
              : ''}"
          >
            <button
              class="remove-btn bg-transparent border-0"
              on:click={(e) => {
                e.stopImmediatePropagation();
                if (type == 1) {
                  $form.recurringOpenType = '';
                  $form.recurringOpenOn = '';
                } else {
                  $form.recurringDueType = '';
                  $form.recurringDueOn = '';
                }
                selectedDay = undefined;
                recurringSubType = undefined;
                return false;
              }}
              ><img
                alt=""
                src="/images/close.svg"
              /></button
            >
            <div
              class="number-unit background-blue text-white d-flex align-items-center justify-content-center"
            >
              <img
                class="icon-16"
                alt=""
                src={recurringSubType == 5 ? '/images/calendar-white.svg' : '/images/calendar.svg'}
              />
            </div>
            <div class="d-flex flex-column day-every">
              <span class="font-weight-600">Custom</span>
            </div>
          </button>
        </div>

        {#if recurringSubType == 5}
          <div class="col-md-6 mb-2 align-items-center justify-content-center">
            <div
              class="d-flex flex-row align-items-center repeats-block-content justify-content-start h-100 position-relative {$errors.recurringOpenOn ||
              $errors.recurringDueOn
                ? 'error'
                : ''}"
            >
              <label
                for=""
                class="me-2">Repeats<br />on</label
              >
              <div class="position-relative">
                <Select
                  isDisabled={disabledAllFields}
                  showChevron={true}
                  isClearable={true}
                  items={days28}
                  placeholder="Day"
                  bind:selectedValue={selectedDay}
                  optionIdentifier="id"
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  containerClasses="form-control"
                  containerStyles="width:100px; height:35px;"
                  on:select={(ev) => {
                    if (type == 1) {
                      $form.recurringOpenOn = ev.detail.id;
                      handleChange(customInputEvent('recurringOpenOn', ev.detail.id));
                    } else {
                      $form.recurringDueOn = ev.detail.id;
                      handleChange(customInputEvent('recurringDueOn', ev.detail.id));
                    }
                  }}
                ></Select>
                {#if type == 1 && $errors.recurringOpenOn}
                  <label class="formError recuring-error">
                    {$errors.recurringOpenOn}
                  </label>
                {/if}
                {#if type == 2 && $errors.recurringDueOn}
                  <label class="formError recuring-error">
                    {$errors.recurringDueOn}
                  </label>
                {/if}
              </div>
              <label
                class="ms-2"
                for="">Every 3 Month</label
              >
            </div>
          </div>
        {/if}

        {#if type == 1 && $errors.recurringOpenType != undefined}
          <label
            for=""
            class="formError recuring-error">{$errors.recurringOpenType}</label
          >
        {/if}

        {#if type == 2 && $errors.recurringDueType != undefined}
          <label
            for=""
            class="formError recuring-error">{$errors.recurringDueType}</label
          >
        {/if}
      {:else}
        {#each dateRecurringSubTypes as dateRecurringSubType}
          <div class="col-md-3 mb-2">
            <button
              disabled={disabledAllFields}
              on:click={() => {
                if (type == 1) {
                  $form.recurringOpenType = dateRecurringSubType.id;
                  $form.recurringOpenOn = dateRecurringSubType.value;
                  handleChange(customInputEvent('recurringOpenType', dateRecurringSubType.id));
                  handleChange(customInputEvent('recurringOpenOn', dateRecurringSubType.value));
                } else {
                  $form.recurringDueType = dateRecurringSubType.id;
                  $form.recurringDueOn = dateRecurringSubType.value;

                  handleChange(customInputEvent('recurringDueType', dateRecurringSubType.id));
                  handleChange(customInputEvent('recurringDueOn', dateRecurringSubType.value));
                }
                recurringSubType = dateRecurringSubType.id;
              }}
              class="d-flex flex-row align-items-center button-weekly position-relative w-100 bg-white {recurringSubType ==
              dateRecurringSubType.id
                ? 'active'
                : ''}"
            >
              <button
                class="remove-btn bg-transparent border-0"
                on:click={(e) => {
                  e.stopImmediatePropagation();
                  if (type == 1) {
                    $form.recurringOpenType = '';
                    $form.recurringOpenOn = '';
                  } else {
                    $form.recurringDueType = '';
                    $form.recurringDueOn = '';
                  }
                  recurringSubType = undefined;
                  return false;
                }}
                on:click={(e) => {
                  e.stopImmediatePropagation();
                  recurringSubType = undefined;
                  return false;
                }}
                ><img
                  alt=""
                  src="/images/close.svg"
                /></button
              >
              <div class="number-unit d-flex align-items-center justify-content-center">
                {dateRecurringSubType.value}<sup>{dateRecurringSubType.suffix}</sup>
              </div>
              <div class="d-flex flex-column day-every">
                <small>of Every</small>
                <span class="font-weight-600">Month</span>
              </div>
            </button>
          </div>
        {/each}

        <!-- <div class="col-md-3 mb-2">
							  <button
							  disabled={disabledAllFields}
								on:click={()=>{
									if(type ==1){
										$form.recurringOpenType=1;
										$form.recurringOpenOn=1;
										 handleChange(customInputEvent('recurringOpenType', 1));
										 handleChange(customInputEvent('recurringOpenOn', 1));
									  }else{
										$form.recurringDueType=1;
										$form.recurringDueOn=7;

										 handleChange(customInputEvent('recurringDueType', 1));
										 handleChange(customInputEvent('recurringDueOn', 7));
									  }
									  recurringSubType=1;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==1?'active':''}">
									 <div class="number-unit  d-flex align-items-center justify-content-center ">
										{#if type ==1}
										  1<sup>st</sup>
										{:else}
										  7<sup>th</sup>
										{/if}
									  </div>
									  <div class="d-flex flex-column day-every">
										<small>of Every</small>
										<span class="font-weight-600">Month</span>
									  </div>

							  </button>
						  </div>

						   <div class="col-md-3  mb-2">
							  <button
							  disabled={disabledAllFields}
							   on:click={()=>{

								 if(type ==1){
										$form.recurringOpenType=2;
										$form.recurringOpenOn=14;
										   handleChange(customInputEvent('recurringOpenType', 2));
										 handleChange(customInputEvent('recurringOpenOn', 14));
								  }else{
									  $form.recurringDueType=2;
									  $form.recurringDueOn=14;
									   handleChange(customInputEvent('recurringDueType', 2));
										 handleChange(customInputEvent('recurringDueOn', 14));
									}
									recurringSubType=2;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==2?'active':''}">
								<div class="number-unit  d-flex align-items-center justify-content-center ">14<sup>th</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>of Every</small>
								  <span class="font-weight-600">Month</span>
								</div>
							  </button>
						  </div>
						   <div class="col-md-3  mb-2">
							  <button
							  disabled={disabledAllFields}
							   on:click={()=>{
								   if(type ==1){
										$form.recurringOpenType=3;
										$form.recurringOpenOn=21;
										 handleChange(customInputEvent('recurringOpenType', 3));
										 handleChange(customInputEvent('recurringOpenOn', 21));
									}else{
									  $form.recurringDueType=3;
									  $form.recurringDueOn=21;
										handleChange(customInputEvent('recurringDueType', 3));
										handleChange(customInputEvent('recurringDueOn', 21));
									}

									recurringSubType=3;
								}}
							  class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==3?'active':''}">
								<div class="number-unit  d-flex align-items-center justify-content-center ">21<sup>st</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>of Every</small>
								  <span class="font-weight-600">Month</span>
								</div>
							  </button>
						  </div>
						   <div class="col-md-3  mb-2">
							  <button
							  disabled={disabledAllFields}
							   on:click={()=>{
								  if(type ==1){
										$form.recurringOpenType=4;
										$form.recurringOpenOn=28;
										 handleChange(customInputEvent('recurringOpenType', 4));
										 handleChange(customInputEvent('recurringOpenOn', 28));
									}else{
									  $form.recurringDueType=4;
									  $form.recurringDueOn=28;
									  handleChange(customInputEvent('recurringDueType', 4));
										handleChange(customInputEvent('recurringDueOn', 28));
									}
									recurringSubType=4;
								}}
							   class="d-flex flex-row align-items-center button-weekly w-100 bg-white {recurringSubType==4?'active':''}">
								<div class="number-unit  d-flex align-items-center justify-content-center ">28<sup>th</sup></div>
								<div class="d-flex flex-column day-every">
								  <small>of Every</small>
								  <span class="font-weight-600">Month</span>
								</div>
							  </button>
						  </div> -->

        <div class="col-md-3 mb-2">
          <button
            disabled={disabledAllFields}
            on:click={() => {
              if (type == 1) {
                $form.recurringOpenType = 5;
                $form.recurringOpenOn = '';
                selectedDay = undefined;
                handleChange(customInputEvent('recurringOpenType', 5));
              } else {
                $form.recurringDueType = 5;
                $form.recurringDueOn = '';
                selectedDay = null;
                handleChange(customInputEvent('recurringDueType', 5));
              }
              recurringSubType = 5;
            }}
            class="d-flex flex-row align-items-center button-weekly position-relative w-100 bg-white {recurringSubType ==
            5
              ? 'active'
              : ''}"
          >
            <button
              class="remove-btn bg-transparent border-0"
              on:click={(e) => {
                e.stopImmediatePropagation();
                if (type == 1) {
                  $form.recurringOpenType = '';
                  $form.recurringOpenOn = '';
                } else {
                  $form.recurringDueType = '';
                  $form.recurringDueOn = '';
                }
                recurringSubType = undefined;
                return false;
              }}
              ><img
                alt=""
                src="/images/close.svg"
              /></button
            >
            <div
              class="number-unit background-blue text-white d-flex align-items-center justify-content-center"
            >
              <img
                class="icon-16"
                alt=""
                src={recurringSubType == 5 ? '/images/calendar-white.svg' : '/images/calendar.svg'}
              />
            </div>
            <div class="d-flex flex-column day-every">
              <span class="font-weight-600">Custom</span>
            </div>
          </button>
        </div>

        {#if recurringSubType == 5}
          <div class="col-md-6 mb-2 align-items-center justify-content-center">
            <div
              class="d-flex flex-row align-items-center repeats-block-content justify-content-start h-100 position-relative {$errors.recurringOpenOn ||
              $errors.recurringDueOn
                ? 'error'
                : ''}"
            >
              <label
                for=""
                class="me-2">Repeats on</label
              >
              <div class="position-relative">
                <Select
                  isDisabled={disabledAllFields}
                  showChevron={true}
                  isClearable={true}
                  items={days28}
                  placeholder="Day"
                  bind:selectedValue={selectedDay}
                  optionIdentifier="id"
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  containerClasses="form-control"
                  containerStyles="width:100px; height:35px;"
                  on:select={(ev) => {
                    if (type == 1) {
                      $form.recurringOpenOn = ev.detail.id;
                      handleChange(customInputEvent('recurringOpenOn', ev.detail.id));
                    } else {
                      $form.recurringDueOn = ev.detail.id;
                      handleChange(customInputEvent('recurringDueOn', ev.detail.id));
                    }
                  }}
                ></Select>
                {#if type == 1 && $errors.recurringOpenOn}
                  <label class="formError">
                    {$errors.recurringOpenOn}
                  </label>
                {/if}
                {#if type == 2 && $errors.recurringDueOn}
                  <label class="formError">
                    {$errors.recurringDueOn}
                  </label>
                {/if}
              </div>
              <label
                class="ms-2"
                for="">of Every Month</label
              >
            </div>
          </div>
        {/if}

        {#if type == 1 && $errors.recurringOpenType != undefined}
          <label class="formError recuring-error">{$errors.recurringOpenType}</label>
        {/if}

        {#if type == 2 && $errors.recurringDueType != undefined}
          <label class="formError recuring-error">{$errors.recurringDueType}</label>
        {/if}
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  .button-weekly.active .remove-btn {
    display: block;
  }

  .button-weekly .remove-btn {
    display: none;
    position: absolute;
    right: -8px;
    top: -8px;
    width: 17px;
    background: $lead-color !important;
    width: 16px;
    height: 16px !important;
    border-radius: 6px !important;
    line-height: 0px;
    padding: 0px;
    z-index: 1;
    img {
      width: 8px;
    }
    &:hover {
      background: $black-color !important;
    }
  }
  .number-unit {
    width: 40px;
    height: 28px;
    border-radius: 6px;
    font-size: 14px;
    margin-right: 7px;
    background-color: $silver-color;
    color: $black-color;
    sup {
      font-size: 11px;
    }
  }
  .day-every {
    line-height: 16px;
    span {
      font-size: 13px;
      font-weight: 500;
    }
  }
  .button-weekly {
    border-radius: 4px;
    border: 1px solid $white-color;
    padding: 2px 5px;
    &.active {
      border: 1px solid $blue-color;
      background: $blue-color;
      .number-unit {
        background: $blue-color;
        color: $white-color;
      }
    }
  }
  .hrline {
    background: #cdd9e9;
    height: 1px;
  }

  .recuring-error {
    right: auto;
    left: 13px;
    display: inline-block;
    max-width: 167px;
  }
</style>
